import { createRender } from './types';
import { RovoAwarenessHomeBannerComponent } from './components';
import { type JSX } from 'react/jsx-runtime';

export const render: (renderProps: { onDismissed: () => void }) => JSX.Element | null =
	createRender(({ onDismissed }) => <RovoAwarenessHomeBannerComponent onDismissed={onDismissed} />);

export default render;
